import { render } from "./FamousArtists.vue?vue&type=template&id=3c7caef2"
import script from "./FamousArtists.vue?vue&type=script&lang=js"
export * from "./FamousArtists.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__